// extracted by mini-css-extract-plugin
export default {"disable":"DisableButton__disable--TIUTA"};